import branchManagementBinManifestComponent from './bin_manifest.component';

let branchManagementBinManifestModule = angular.module('branchManagementBinManifest', [])
  .component('branchManagementBinManifest', branchManagementBinManifestComponent)
  .name;

export default branchManagementBinManifestModule; 



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/bin_manifest/index.js